export function getObjectIndexFromClassName(node) {
  // Grab the index from the class name (should use an ID instead?).
  const index = [...node.classList]
    .map((klass) => klass.match(/DesignObject-(-?\d+)/))
    .filter(Boolean)[0][1]

  return parseInt(index)
}
